import { environment } from 'src/environments/environment'
import { AccessRights } from 'src/app/features/role/user-role/user-role'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { Observable } from 'rxjs'
import { filter, take } from 'rxjs/operators'

@Component({
  selector: 'configuration-option-tagsearch-placeholder-branding-card',
  templateUrl: './tagsearch-placeholder-branding-card.component.html',
  styleUrls: ['./tagsearch-placeholder-branding-card.component.scss']
})
export class ConfigurationOptionTagSearchPlaceholderBrandingCardComponent
  implements OnInit
{
  public form: UntypedFormGroup
  @Input() isCollapsed: any = false
  //public isCollapsed = false
  public accessRights = AccessRights
  public availableLanguages = environment.frontendLanguages.reduce(
    (acc, curr) => {
      if (curr != 'xx') return (acc[curr] = true), acc
      else return acc
    },
    {}
  )

  @Output() onSubmit = new EventEmitter<any>()
  @Input() formValues$: Observable<any>

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      tagSearchPlaceholderNl: [],
      tagSearchPlaceholderEn: [],
      tagSearchHeaderNl: [],
      tagSearchHeaderEn: [],
      tagSearchPlaceholderFr: [],
      tagSearchPlaceholderDe: [],
      tagSearchHeaderFr: [],
      tagSearchHeaderDe: []
    })

    this.formValues$
      .pipe(
        filter(
          (formValues) =>
            formValues?.en_tagsearch_placeholder &&
            formValues?.nl_tagsearch_placeholder &&
            formValues?.en_tagsearch_header &&
            formValues?.nl_tagsearch_header
        ),
        take(1)
      )
      .subscribe((formValues) => {
        if (
          formValues?.en_tagsearch_placeholder &&
          formValues?.nl_tagsearch_placeholder
        ) {
          this.form?.patchValue({
            tagSearchPlaceholderNl: formValues.nl_tagsearch_placeholder,
            tagSearchPlaceholderEn: formValues.en_tagsearch_placeholder,
            tagSearchPlaceholderFr: formValues.fr_tagsearch_placeholder,
            tagSearchPlaceholderDe: formValues.de_tagsearch_placeholder
          })
        }

        if (
          formValues?.en_tagsearch_header &&
          formValues?.nl_tagsearch_header
        ) {
          this.form?.patchValue({
            tagSearchHeaderNl: formValues.nl_tagsearch_header,
            tagSearchHeaderEn: formValues.en_tagsearch_header,
            tagSearchHeaderFr: formValues.fr_tagsearch_header,
            tagSearchHeaderDe: formValues.de_tagsearch_header
          })
        }
      })
  }

  public onFormSubmit() {
    if (!this.form.valid) {
      return
    }

    const {
      tagSearchPlaceholderNl,
      tagSearchPlaceholderEn,
      tagSearchHeaderNl,
      tagSearchHeaderEn,
      tagSearchPlaceholderFr,
      tagSearchPlaceholderDe,
      tagSearchHeaderFr,
      tagSearchHeaderDe
    } = this.form.controls

    this.onSubmit.emit({
      nl_tagsearch_placeholder: tagSearchPlaceholderNl.value,
      en_tagsearch_placeholder: tagSearchPlaceholderEn.value,
      nl_tagsearch_header: tagSearchHeaderNl.value,
      en_tagsearch_header: tagSearchHeaderEn.value,
      fr_tagsearch_placeholder: tagSearchPlaceholderFr.value,
      de_tagsearch_placeholder: tagSearchPlaceholderDe.value,
      fr_tagsearch_header: tagSearchHeaderFr.value,
      de_tagsearch_header: tagSearchHeaderDe.value
    })
  }
}
